import React from "react";
import { Grid, Box, Typography } from "@mui/material";
import { DocumentCard } from "../../../component/molecule";
import { checkIsImageFile } from "../../../core/Constant";

const DocumentGrid = ({ 
  items, 
  isFolder, 
  formatTitle, 
  handleCardAction, 
  getRelativeTime, 
  showTime = false,
  emptyMessage = "Currently, there are no Documents available for this course.",
  fileBtnText = "View Document",
  folderBtnText = "View Folder",
  selectedDocId,
  baseUrl
}) => {
  if (items.length === 0) {
    return (
      <span className="no-review-text">
        {emptyMessage}
      </span>
    );
  }

  return (
    <Grid container rowGap={2} columnGap={4}>
      {items.map((item, index) => {
        const folder = isFolder(item);
        
        const isImageFile = checkIsImageFile(item.name, folder);
        const isDocSelected = !folder && selectedDocId && String(item.id) === String(selectedDocId);
        const btnText = folder
          ? folderBtnText
          : (isDocSelected ? "Selected" : fileBtnText);
        const btnClass = isDocSelected ? "btn btn-secondary" : "btn btn-primary";

        return (
        <Box key={item.id || index} sx={{ display: 'flex', flexDirection: 'column' }}>
          <DocumentCard
            isFolder={folder}
            isImage={isImageFile}
            title={formatTitle(item.name)}
            btnText={btnText}
            classStyle={btnClass}
            isDisabled={isDocSelected}
            onViewDocument={() => handleCardAction(item)}
            item={item}
              baseUrl={baseUrl}
          />
          {showTime && item.viewed_at && (
            <Typography
              sx={{
                fontSize: 12,
                color: "#363436",
                fontFamily: "Montserrat",
                mt: 1,
                pl: 1,
              }}
            >
              Last viewed : {getRelativeTime(item.viewed_at)}
            </Typography>
          )}
        </Box>
      )})}
    </Grid>
  );
};

export default DocumentGrid;